/**
 * Service to abstract functionality  for REST RPC API calls
 */
import Util from './util';
import Auth from './auth';
import Logger from '@utils/logger';

const Rest = {
  /**
   *
   * @param handler
   * @param handlerActionClass
   * @param payload
   */
  getApi(handler: string, handlerActionClass: string, payload: object) {
    const host = Util.getBackendHost();
    const now = Auth.getAWSAuthDateString();
    const accountId = Util.getCookie('ACCOUNT_ID');
    const jwt = Util.getCookie('JWT');

    const API_URL = `${host}/restrpc/account/${accountId}/handler/${handler}`;

    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
    };
    const awsAuth = Auth.getAWSAuthString(now, handlerActionClass);

    const finalPayload = {
      ...payload,
      authString: awsAuth,
      dateString: now,
      clientUserAgent: navigator.userAgent,
    };

    return new Promise((resolve, reject) => {
      fetch(API_URL, {
        method: 'POST',
        headers,
        body: JSON.stringify(finalPayload),
      }).then((response) => resolve(response.json()))
        .catch((error) => reject(error));
    });
  },

  get(handler: string, handlerActionClass: string, payload: object) {
    const getApiCall = () => this.getApi(handler, handlerActionClass, payload);
    if (Auth.isJwtValid()) {
      return getApiCall();
    }
    return Auth.obtainJWTToken()
      .then((jwt) => {
        if (jwt) {
          Util.setCookie('JWT', jwt);
          return getApiCall();
        }
        Logger.warn('No JWT Token Found');
        return Promise.resolve();
      })
      .catch(() => {
        Logger.error('Error occured while refreshing the JWT');
      });
  },
};

export default Rest;
